import React from 'react';

import {connect} from 'react-redux';

import {useGetActualPhone} from 'desktop/hooks/useGetActualPhone/useGetActualPhone';
import {ApplicationStoreType} from 'desktop/store';

import {flags} from 'libs/rollout';

import {getIsOrderHasActiveSubscriptionCL} from '../../store/selectors/orderReviewItems/orderReviewItems';

import s from './paymentFooterSubscriptionDisclaimer.scss';

type PropsType = {
    isCartHasActiveSubscriptionCL: boolean;
};

/**
 * Component is responsible for force registration in some cases and just provide the markup for auth popup
 *
 * @constructor
 */
export const PaymentFooterSubscriptionDisclaimer: React.FC<PropsType> = ({
    isCartHasActiveSubscriptionCL,
}) => {
    const phone = useGetActualPhone();
    if (!isCartHasActiveSubscriptionCL || flags.checkoutCLConsent.isEnabled()) return null;
    return (
        <p className={s.content}>
            By clicking ‘Place Order’, you authorize GlassesUSA.com to charge your credit card on a
            recurring basis according to the delivery frequency you selected in your subscription.
            If we are unable to charge the payment method associated with your subscription, you
            authorize us to update with another payment method you have on file. Your subscription
            will remain in effect until canceled. You can cancel any time via ‘My Account’, or by
            calling {phone}. Your subscription price may change based on the item(s) in your
            subscription at the time it is processed.
        </p>
    );
};

/**
 * Map state to props
 * @param {ApplicationStoreType} store - redux store
 * @returns {PropsType} props
 */
const mapStateToProps = (store: ApplicationStoreType) => ({
    isCartHasActiveSubscriptionCL: getIsOrderHasActiveSubscriptionCL(store),
});

export const PaymentFooterSubscriptionDisclaimerConnected = connect(mapStateToProps)(
    PaymentFooterSubscriptionDisclaimer,
);
